
export default function Services() {
  return (
    <section id="servicos" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Nossos <span className="text-red-600">Serviços</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Oferecemos os melhores serviços de entrega de gás com qualidade e segurança
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-3xl p-8 text-center border-2 border-red-200 hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-truck-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Entrega Rápida</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Entregamos seu botijão de gás em até 2 horas, direto na sua casa com toda segurança.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl p-8 text-center border-2 border-blue-200 hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Qualidade Garantida</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Trabalhamos apenas com botijões certificados e seguros, garantindo sua tranquilidade.
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-3xl p-8 text-center border-2 border-red-200 hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-customer-service-2-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Atendimento 24h</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Estamos sempre prontos para atender você, todos os dias da semana.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl p-8 text-center border-2 border-blue-200 hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-money-dollar-circle-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Preço Justo</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Oferecemos os melhores preços da região com frete grátis para sua comodidade.
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-3xl p-8 text-center border-2 border-red-200 hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-refresh-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Troca de Botijão</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Fazemos a troca do seu botijão vazio por um novo, de forma rápida e prática.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl p-8 text-center border-2 border-blue-200 hover:shadow-2xl transition-all transform hover:scale-105">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-fill text-white text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Cobertura Total</h3>
              <p className="text-gray-700 text-lg leading-relaxed">
                Atendemos toda a região de Itirapina e cidades vizinhas com excelência.
              </p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <div className="bg-gradient-to-r from-red-600 to-blue-600 rounded-3xl p-12 text-white">
              <h3 className="text-3xl md:text-4xl font-bold mb-6">
                Precisa de Gás Agora?
              </h3>
              <p className="text-xl mb-8 max-w-2xl mx-auto">
                Não fique sem gás em casa! Faça seu pedido agora e receba em até 2 horas.
              </p>
              <button 
                onClick={() => document.getElementById('pedido')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-red-600 px-12 py-4 rounded-full text-xl font-bold hover:bg-gray-100 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer shadow-2xl"
              >
                <i className="ri-shopping-cart-fill mr-3"></i>
                FAZER PEDIDO AGORA
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
